export const AVAILABLE_STATUSES = [
  {
    text: "Submitted",
    value: "submitted",
  },
  {
    text: "In Review",
    value: "in_review",
  },
  {
    text: "Awaiting Client Response",
    value: "awaiting_creditor_response",
  },
  {
    text: "Gathering Evidence From Client",
    value: "gathering_evidence_from_client",
  },
  {
    text: "Investigated, But Debtor Disagrees",
    value: "investigated_but_debtor_disagrees",
  },
  {
    text: "Resolved",
    value: "resolved",
  },
];

export const AVAILABLE_DATA_SOURCES = [
  {
    text: "Aktos",
    value: "",
  },
  {
    text: "E-Oscar",
    value: "e_oscar",
  },
];
